import S3Client from 'aws-s3';
import {hideAlert, showAlert} from '../actions/miscellaneousActions';
import {IAction, IThunkAction} from '../interfaces';
import {getUserData} from '../services/utilityServices';
import {store} from '../store';
import axios from 'axios';
import 'whatwg-fetch';

export function dispatch<T extends IAction>(action: T | IThunkAction): any {
    if ((action as IAction).type) {
        return store.dispatch(action as IAction);
    }
    return store.dispatch(action as IThunkAction);
}

export function getCurrentUserUUID() {
    return store.getState().login.get('userUID') ? store.getState().login.get('userUID') : getUserData().userUID;
}

export function isMobileDevice() { 
    return navigator.userAgent.toString().indexOf('Mobile') > -1;
}


export function isEmpty(obj: Object) {
    if (obj instanceof Object) {
        return false;
    }
    return Object.keys(obj).length <= 0 || !obj;

}

export function isFormEmpty(values: Object, ignoreList?: Array<any>) {
    let ignoreAllIn = ['middleName', 'jobDesc', 'modules'];
    if (ignoreList && ignoreList.length) {
        ignoreAllIn = ignoreAllIn.concat(ignoreList);
    }
    let isFormEmpty1 = false;
    for (const key in values) {
        if ((values[key] || '').length <= 0 && ignoreAllIn.indexOf(key) < 0) {
            showAlert({
                title: 'Required Fields Cannot be empty',
                text: 'Please Fill all the fields.',
                type: 'warning',
                closeOnConfirm: true
            }, 'validation');
            isFormEmpty1 = true;
            setTimeout(() => {
                hideAlert();
            }, 5000);
            break;
        }
    }
    return isFormEmpty1;
}

export function isArrayEmpty(values: any[], titleText: string) {
    if (values.length <= 0) {
        showAlert({
            title: titleText,
            text: 'To submit the form',
            type: 'warning',
            closeOnConfirm: true
        }, 'validation');
        return true;
    }
    return false;
}

export async function asyncForEach(array: any[], callback?: Function) {
    for (let i = 0; i < array.length; i++) {
        await callback(array[i], i, array);
    }
}

export function objectToArray(obj) {
    if (typeof obj !== 'object') {
        return [];
    }
    return Object.keys(obj).map(key => {
        return obj[key];
    });
}

export async function uploadDocsToS3(file, dirName) {
    try {
        const config = {
            bucketName: '', // 'harish-soni-1',
            dirName: dirName,  //  'testing', /* optional */
            region: 'us-west-2', // 'us-east-1',
            accessKeyId: '',
            secretAccessKey: ''
        };

        return S3Client
            .uploadFile(file, config)
            .then(data => {
                return data;
            })
            .catch(err => console.error(err));
    } catch (error) {
        throw new Error(error);

    }
}

export async function uploadOnboardingDocs(file: File[], dirName: string) {
    const images = [];
    const start = async () => {
        await asyncForEach(file, async (base64) => {
            const s3object = await uploadDocsToS3(file, dirName);
            images.push(s3object.location);
        });
        return images;
    };
    return start();
}

export function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
}

export function getBase64Image(img) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL('image/png');
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
}

export async function encodeImageFileAsURL(file) {
    const reader = new FileReader();
    reader.onloadend = await function () {
        return reader.result;
    };
    reader.readAsDataURL(file);
}

export async function toDataUrl(url, callback) {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
        const reader = new FileReader();
        reader.onloadend = async () => {
            await callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

export function getBase64(url) {
    try {
        return axios.get(url, {
            responseType: 'arraybuffer'
        }).then(response => new Buffer(response.data, 'binary').toString('base64'));
    } catch (error) {
        throw new Error(error);
    }
}

export function getBase64ForPrint(url) {

    return axios.get(url, {

        responseType: 'arraybuffer',

        headers: {

            'Cache-Control': 'no-cache',

            'Pragma': 'no-cache',

            'Expires': '0',

        },

    }).then(response => new Buffer(response.data, 'binary').toString('base64'));

}

export async function base64ToFile(dataURL, fileName) {
    const formData = new FormData();
    let arr = dataURL.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, {type: mime});

}

export const userUniqueID = (state) => state.login.get('token') ?
    parseJwt(state.login.get('token')).UniqueID : getUserData().userUID;

export const userName = (state) => state.login.get('token') ? 
    parseJwt(state.login.get('token')).MiddleName === null ?
    /*tslint:disable-next-line*/
    `${parseJwt(state.login.get('token')).FirstName} ${parseJwt(state.login.get('token')).LastName}`:
    `${parseJwt(state.login.get('token')).FirstName} ${parseJwt(state.login.get('token')).MiddleName} ${parseJwt(state.login.get('token')).LastName}`
    : parseJwt(getUserData().token).MiddleName === null ? 
    `${parseJwt(getUserData().token).FirstName} ${parseJwt(getUserData().token).LastName}`
    : `${parseJwt(getUserData().token).FirstName} ${parseJwt(getUserData().token).MiddleName} ${parseJwt(getUserData().token).LastName}`;

// export const userName = (state) => `${parseJwt(getUserData().token).FirstName} ${parseJwt(getUserData().token).MiddleName} ${parseJwt(getUserData().token).LastName}`;


export const addZero = (str: number | string) => {
    if (str.toString().length === 1) {
        return `000${str}`;
    }
    if (str.toString().length === 2) {
        return `00${str}`;
    }
    if (str.toString().length === 3) {
        return `0${str}`;
    }
    return str;
};

export const getBase64BIT = file => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
  };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/generalUtils.ts